import React, { useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { data } from "jquery";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

function PipelineFunnel({ chart_data }) {
  let data_labels = [];
  let datasets_data = [];
  let datasets_color = [];

  const chart = useRef();

  if (!chart.current) {
    chart_data?.forEach((item) => {
      data_labels.push(item.name);
      datasets_data.push(item.total);
      datasets_color.push(item.chart_color);
    });
  } else {
    chart.current = true;
  }

  const data = {
    labels: data_labels,
    datasets: [
      {
        data: datasets_data,
        backgroundColor: datasets_color,
        borderRadius: 6,
        barThickness: 20,
      },
    ],
  };

  const options = {
    indexAxis: "y", // Makes it horizontal
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true, // value will appear only on hover
        callbacks: {
          // ✅ show ONLY value on hover
          label: function (context) {
            return context.raw; // just number
          },
          title: function () {
            return ""; // ❌ remove label title
          },
        },
      },
      datalabels: {
        display: false, // prevents constant values on bars
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 1, // forces 1,2,3,4,5
        },
        grid: {
          display: false, // ❌ remove vertical grid
        },
      },
      y: {
        grid: {
          display: false, // ❌ remove horizontal grid
        },
      },
    },
  };
  return <Bar data={data} options={options} />;
}

export default PipelineFunnel;
